import { ComponentView } from "binder";
import { OverlayViewModel } from "./overlay-viewModel"

export class OverlayView extends ComponentView<OverlayViewModel>{
    GetViewUniqueId(): string {
        return "V-04B771C7-F39E-44D1-9188-1F84C1605E0F"
    }
    loadHtml(): string {
        let element = require('./overlay.html').default;
        let style = require('./overlay.less');
        return element;
    }
    constructor() {
       super();
    }
    public set showing(v: boolean) { 
        this._showing = v;
        if(this.firstlevelElement)
            this.updateOverlayStatus();
    } public get showing(): boolean { return this._showing;} private _showing: boolean;
    private updateOverlayStatus(){
        if(this.showing){
            (<HTMLElement>this.firstlevelElement).style.display="block";
            setTimeout(()=>{
                (<HTMLElement>this.firstlevelElement).classList.add("overlay-visible");
            },0)
        }else {
            (<HTMLElement>this.firstlevelElement).classList.remove("overlay-visible");
            setTimeout(()=>{
                (<HTMLElement>this.firstlevelElement).style.display="none";
            },100)
            
        }
            
    }
    public set contentwidth(v: string) { this._contentwidth = v; } public get contentwidth(): string { return this._contentwidth;} private _contentwidth: string;
    public set contentheight(v: string) { this._contentheight = v; } public get contentheight(): string { return this._contentheight;} private _contentheight: string;


    onRenderCompleted(){
        this._childrenPlaceholder = this.firstlevelElement.querySelector('.childrenPlaceHolder');
        this.updateOverlayStatus();
    }
    private _childrenPlaceholder:Element;
    
    append(...nodes: (Node | string)[]): void{
        this._childrenPlaceholder.append(...nodes);
    }

    midCreator(t){
        return `1fr ${t} 1fr`;
    }
    midCreatorReverse(t){
        return t.split(' ')[1];
    }
}
